import { render, staticRenderFns } from "./Revive.vue?vue&type=template&id=5d9561b1&scoped=true&"
import script from "./Revive.vue?vue&type=script&lang=js&"
export * from "./Revive.vue?vue&type=script&lang=js&"
import style0 from "./Revive.vue?vue&type=style&index=0&id=5d9561b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9561b1",
  null
  
)

export default component.exports